import { createPlanningObjectsReducer } from "../planningObjects"

export default createPlanningObjectsReducer("operations")
